import React from 'react';
import PropTypes from 'prop-types';

import PageSection from '../../design-system/PageSection';
import Modal from '../../components/Modal';
import { HeadingPara } from '../../design-system/Headings';
import phrasesType from '../../proptypes/phrases';
import Container from '../../design-system/Containers';
import Paragraph from '../../design-system/Paragraph';
import { Button } from '../../design-system/Buttons';

const ModalGradient = () => <div className="ss_modal-background" />;

export default function DownloadingModal({
  phrases,
  visible,
  onCloseClick,
}) {
  return (
    <Modal show={visible} onClose={onCloseClick} limitWidth>
      <section className="ss_modal">
        <PageSection container={false}>
          <ModalGradient />
          <div className="ss_modal_content">
            <Container center myLg>
              <HeadingPara el="h2" py0 my0>
                {phrases.title}
              </HeadingPara>
              <Paragraph body secondary>
                {phrases.description}
              </Paragraph>
              <Button onClick={onCloseClick}>
                {phrases.buttonLabel}
              </Button>
            </Container>
          </div>
        </PageSection>
      </section>
    </Modal>
  );
}

DownloadingModal.propTypes = {
  phrases: phrasesType.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
